module.exports = __webpack_public_path__ + "images/material-aa03f747c09e2ff41b1adac4eedc6e60.jpg";